import { WistiaMediaData } from '@monoimin/sb-types';

export const parseWistiaId = (src: string) => {
  try {
    const fullURL = new URL(src);
    return fullURL.pathname.split('/medias/')[1].replace('/', '');
  } catch (error) {
    console.error(error);
  }
};

export const dateFormatter = (timestamp: number) => {
  try {
    return new Date(timestamp).toISOString();
  } catch (error) {
    return '';
  }
};

export const formatVideoDuration = (durationInSeconds: number) => {
  const minutes = Math.floor(durationInSeconds / 60);
  const seconds = Math.round(durationInSeconds % 60);

  return `PT${minutes}M${seconds}S`;
};

export const getWistiaPublicAsset = (data: WistiaMediaData) => {
  return data.assets.find((asset) => asset.public);
};

export const getWistiaPublicAssetThumbnail = (data: WistiaMediaData) => {
  const publicAsset = getWistiaPublicAsset(data);

  if (!publicAsset) {
    return '';
  }

  const extensionRegex = /\.[a-z0-9]+$/i;

  return publicAsset.url.replace(extensionRegex, `.jpg`);
};

export const getWistiaThumbnailUrl = (data: WistiaMediaData) => {
  if (data?.embedOptions?.unalteredStillImageAsset) {
    return data.embedOptions.unalteredStillImageAsset.url;
  }

  return getWistiaPublicAssetThumbnail(data);
};
